import type { ScoreBreakdown, Track } from "@roomate/core";

/** The track a candidate row may show. People never have one (NG3); the kind check is a second guard behind the core's null. */
export function visibleTrack(b: Pick<ScoreBreakdown, "kind" | "track">): Track | null {
  return b.kind === "agent" ? (b.track ?? null) : null;
}

/** `merged 9/10 · 7 first try`, plus ` · 1 reverted` when any landed work came back (learned-routing spec §4.6). */
export function trackLine(t: Track): string {
  const base = `merged ${t.landed}/${t.attempts} · ${t.firstTry} first try`;
  return t.reverted > 0 ? `${base} · ${t.reverted} reverted` : base;
}

/** `claude-sonnet-5-5 6/7 · claude-opus-5-5 3/3`: landed/attempts per run model, most attempts first. */
export function byModelLine(t: Track): string {
  return t.byModel.map((m) => `${m.model} ${m.landed}/${m.attempts}`).join(" · ");
}
